import {
  Row,
  RowContainer,
} from "@circle-react-uikit/SkeletonLoader/components";

export const StorageDistribution = () => (
  <div className="bg-primary border-primary my-6 animate-pulse rounded-lg border p-6">
    <RowContainer lg>
      <Row xl />
    </RowContainer>
    <RowContainer lg className="mt-4 overflow-hidden rounded-full">
      <Row full xxl />
    </RowContainer>
  </div>
);
